<template>

    <!-- <div class="expanded">
        <Avatar class="comment-avatar" :src="null" :alt="'A'" />
        <div class="comment-body w-100">
            <i class="icon-size-fullscreen float-end expand" @click="toggleExpand()" style="cursor: pointer;"></i>
            <b>John Doe</b><br>
            <p>
                our text, Jesus' profound teaching on love challenges us as believers
                to rise above our natural inclinations toward selfishness and
                retaliation and embrace a radical love that reflect
            </p>
        </div>   
    </div> -->
    <div class="expanded" >
        <div class="d-flex justify-content-between">
            <h5>Replies</h5>
            <i class="icon-size-fullscreen expand" @click="toggleExpand()" style="cursor: pointer;"></i>
        </div>
        <!-- <div class="row row-cols-lg-2 row-cols-md-2" v-if="replies?.length > 0"> -->
        <div class="row row-cols-lg-2 row-cols-md-2" v-if="replies?.length > 0">
            <div class="col-lg-6 col-md-6" v-for="(reply) in replies" :key="reply.id">

                <div :class="{ 'd-flex': true, 'comment': true, ...$props.class }">
                    <Avatar class="comment-avatar" :src="comment?.user?.profile_picture" :alt="comment?.user?.name" />
                    <div class="comment-body w-100">
                        <!-- <i class="icon-trash float-end expand" @click="deleteReply()"></i> -->
                        <i class="icon-trash float-end expand" @click="$emit('deleteReply', reply.id)"></i>
                        <b>{{ reply?.user?.name }}</b><br>
                        <p>
                            {{ reply.content }}
                        </p>
                        <!-- <div class="comment-reply w-100" v-if="isReplying || isViewingReply">
                <textarea v-model="newComment.content" :required="isReplying"
                    class="form-control form-control-sm comment-textarea" placeholder="Enter a reply" name="content"
                    v-if="isReplying"></textarea>
                <div class="reply-text" v-if="isViewingReply">
                    {{ firstReply.content }} 
                </div>
            </div> -->

                        <!-- <div class="reply-box">
                <button class="btn btn-sm reply-btn" @click="toggleExpand()">
                    View Replies
                </button>
                <button class="btn btn-sm reply-btn" v-if="hasReply" @click="toggleReply()">
                    {{ isViewingReply ? 'Hide' : 'View' }} Reply
                </button>
                <b class="reply-btn" v-else>
                    <div class="d-flex gap-2" v-if="isReplying">
                        <button class="btn btn-sm " @click="setIsReplying(false)">Cancel</button>
                        <button class="btn btn-sm border-1 send" @click="replyComment()" id="replyComment">Send</button>
                    </div>
                    <div class="btn btn-sm " @click=" setIsReplying(true)" v-else>
                        Reply <i class="icon-action-redo rotate"></i>
                    </div>
                </b>
            </div> -->

                    </div>
                </div>

            </div>
        </div>
        <div v-else>
            <h6 class="mt-4 text-center">No Replies Yet</h6>
        </div>
    </div>
</template>
<script setup>
import Avatar from '@/components/avatar.vue';
import { ref } from 'vue';

const props = defineProps({
    class: Object,
    comment: Object,
    replies: Object
});
const emit = defineEmits({
    "expandedToggled": null,
});

function deleteReply() {
    emit("deleteReply");
}

function toggleExpand() {
    emit("expandedToggled");
}
</script>

<style scoped>
.expand {
    cursor: pointer;
}

.expanded {
    position: absolute;
    width: 100%;
    height: 100vh;
    /* or suitable height */
    /* max-height: 80vh;*/
    overflow-y: auto; 

    z-index: 2;
    background: #fff;
    left: 0;
    top: 0;
    padding: 15px;
}


.comment {
    margin: 15px 0;
    gap: 5px;
    --COMMENT-BG: #fff1ee;
}

.comment-avatar {
    height: 30px;
    width: 30px;
    font-size: 13px !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

.comment-body {
    position: relative;
    background: var(--COMMENT-BG);
    color: var(--PRIMARY-COLOR);
    line-height: 165%;
    border-radius: 8px;
    padding: 10px;
}

.comment-body p {
    padding-top: 10px;
    margin-bottom: 0;
}
</style>